import { IAppState } from '../../redux';

export const selectIsSubagentNotEnoughMoney = (state: IAppState): boolean => {
  return state.publishInfo.isSubagentNotEnoughMoney;
};
